import { observer } from 'mobx-react-lite'
import { type DocumentCreationItemViewModel } from './DocumentCreationItemViewModel'
import { DocumentCreationItem } from '@/features/documents/DocumentCreationModal/DocumentCreationItem'

export interface DocumentCreationItemContainerProps {
  index: number
  vm: DocumentCreationItemViewModel
  onRemove: (index: number) => void
}

export const DocumentCreationItemContainer = observer(
  function DocumentCreationItemContainer({
    index,
    vm,
    onRemove,
  }: DocumentCreationItemContainerProps) {
    return (
      <DocumentCreationItem
        index={index}
        onRemove={onRemove}
        fileName={vm.file.name}
        typeName={vm.typeName}
        isDropdownOpen={vm.dropdown.showing}
        onToggleDropdown={vm.toggleDropdown}
        onCloseDropdown={vm.closeDropdown}
        searchQuery={vm.searchQuery}
        onSearchQueryChange={vm.setSearchQuery}
        types={vm.typeItems}
        otherType={vm.otherTypeItem}
        hasNoMatchingTypes={vm.hasNoMatchingTypes}
        onSelectType={vm.selectType}
      />
    )
  },
)
